// User service feature
import { api } from '@shared/services/api';
import { getToken } from '@shared/services/auth';

interface User {
  id: string;
  email: string;
  name: string;
  picture: string;
  preferences: Record<string, unknown>;
  theme_mode: string;
  created_at: string;
  updated_at?: string;
  is_admin?: boolean;
}

interface IUserService {
  getCurrentUser(): Promise<User>;
}

const UserService: IUserService = {
  async getCurrentUser(): Promise<User> {
    const token = getToken();
    if (!token) throw new Error('No authentication token found');
    const response = await api.get<User>('/api/auth/me');
    if (!response.data) throw new Error('Failed to get user information');
    return response.data;
  },
};

export default UserService;
